import React from "react";
import { MenuItem, TextField } from "@material-ui/core";
import { FieldProps } from "formik";

export interface SelectOption {
  id: string | number;
  name: string | number;
}

interface IProps extends FieldProps {
  placeholder: string;
  label: string;
  disabled?: boolean;
  error?: boolean;
  options: SelectOption[];
}

export const JwlSelect: React.FC<IProps> = ({
  placeholder,
  label,
  field,
  disabled,
  error = false,
  options
}) => {
  return (
    <TextField
      select
      size="small"
      variant="outlined"
      placeholder={placeholder}
      label={label}
      disabled={disabled}
      error={error}
      {...field}
      style={{
        width: "100%",
        marginTop: "12px",
        marginBottom: "4px"
      }}
    >
      {options.map((option: SelectOption) => (
        <MenuItem key={option.id} value={option.id}>
          {option.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export const JwlStringSelect: React.FC<any> = ({
  placeholder,
  label,
  field,
  disabled,
  error = false,
  options
}) => {
  return (
    <TextField
      select
      size="small"
      variant="outlined"
      placeholder={placeholder}
      label={label}
      disabled={disabled}
      error={error}
      {...field}
      style={{
        width: "100%",
        marginTop: "12px",
        marginBottom: "4px"
      }}
    >
      {options.map((option: string, index: number) => (
        <MenuItem key={index} value={option}>
          {option}
        </MenuItem>
      ))}
    </TextField>
  );
};
